import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import CheckmarkIcon from 'components/ui/CheckmarkIcon/CheckmarkIcon'

import s from './Checkmark.scss'


const Checkmark = ({ allWhite, brand, allBrand, black, iconClassName, className, style }) => {
  const rootClassName = cx(s.checkmark, className, {
    [s.allWhite]: allWhite,
    [s.brand]: brand,
    [s.allBrand]: allBrand,
    [s.black]: black,
  })

  return (
    <div className={rootClassName} style={style}>
      <CheckmarkIcon className={cx(s.icon, iconClassName)}  />
    </div>
  )
}

Checkmark.propTypes = {
  allWhite: PropTypes.bool,
  brand: PropTypes.bool,
  allBrand: PropTypes.bool,
  black: PropTypes.bool,
  iconClassName: PropTypes.string,
}

Checkmark.defaultProps = {
  allWhite: false,
  brand: false,
  allBrand: false,
  black: false,
}


export default Checkmark
